import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario2 from "./Scenario2";

export default class Scenario2Part2 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	
	chapterIds = {
		scenario2_1a_s6: 'CALM - Scenario 2 Start - 2A - Segment 6', //a.	Jamie leaves and then returns, asks for more direction - to Respond UI
		scenario2_1a_s7: 'CALM - Scenario 2 End - 2A - Segment 7',	//a.	Jamie leaves, Marco returns and asks what else he should do - to Respond UI	
	}

	constructor(scenario: Scenario2, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get partId(): string {
		return constants.scenarios.scenario2.parts.level2Part2.id;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario2/calm-scenario2-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public start() {
		const context = this;

		context.segment1Step2RespondToJaime();
	}

	private segment1Step2RespondToJaime() {
		var context = this;
		var myHealtheVetOption = "Have him sign up for My HealtheVet. He can learn some more from those online resources, specially designed for veterans.";		
		this.scenario.dialog(
			'CN-C07-L2-000a',
			[{
				text: 'There are probably a few Type II diabetes pamphlets in the patient reception area. Grab him a pamphlet or two. That should be sufficient. ',
				feedback: 'This is the patient’s third time being admitted for Type II diabetes complications. Your critical thinking skills should alert you that he has likely received general patient education pamphlets at this point. Mr. Zolic needs a more tailored education approach.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Answer Rank is Worst
			}, {
				text: 'Our facility offers diabetic education consults for patients. Given that this is his third hospitalization, he may need a personalized approach.',
				scoreType: ScoreType.Best,
				isCorrect: true // Answer Rank is Best
			}, {
				text: myHealtheVetOption,
				scoreType: ScoreType.Ok,
				isCorrect: false // Answer Rank is Okay
			}, {
				text: 'Direct him to the American Diabetes Association online. He can learn from some of the great resources on that site.',
				feedback: 'Though the American Diabetes Association has a lot of good information and resources on Type II diabetes, this patient needs a tailored approach. Remember, this is his third complication in two months!',
				scoreType: ScoreType.Worst,
				isCorrect: false // Answer Rank is Worst
			},],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				this.scenario.gameManager.UiManager.hideAllUis([]);
				if (selectedOption.text.indexOf(myHealtheVetOption) !== -1) {
					context.segment2aStep1EVetReplyReturn();
				} else {
					context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1ConsultJaimeDeparts(), context.partIndx);
				}
			}, 
		);
		context.scenario.updateObjective('Select your Response to Jaime');

	}

	private segment2aStep1EVetReplyReturn() {	// After the detour, the question is presented again via showallUis
		var context = this;
		context.scenario.updateObjective("Wait for an update from Jamie");
		//this.scenario.gameManager.UiManager.hideAllUis([]);
		this.playVideoChapter(this.chapterIds.scenario2_1a_s6, () => {
			context.scenario.updateObjective(' ');
			this.scenario.gameManager.UiManager.showAllUis([]);
			context.scenario.updateObjective('Select your Response to Jamie');
		});

	}

	private segment3Step1ConsultJaimeDeparts() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.playVideoChapter(this.chapterIds.scenario2_1a_s7, () => {
			context.onDone();
		});
	}
}